const dateEvent = new Date(Date.now());
const options = {
  // weekday: "long",
  // year: "numeric",
  month: 'long',
  day: 'numeric',
};

export const getDateES = dateEvent.toLocaleDateString('es-ES', options);

const options2 = {
  // weekday: "long",
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
};
export const getDateNum = dateEvent.toLocaleDateString('es-ES', options2);
